import { Link } from 'react-router-dom'

import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { Collection } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { useCollectionMenu } from '../contexts/CollectionMenuContext.js'

export function CollectionMenu({ collection }: { collection: Collection }) {
  const {
    openCollectionModal,
    openDeleteCollectionModal,
    openOrganizationModal,
  } = useCollectionMenu()

  return (
    <Dropdown placement="bottom-end">
      <Dropdown.ButtonMinimal
        as="div"
        onClick={e => {
          e.stopPropagation()
        }}
      >
        <IconButton
          size="sm"
          variant="tertiaryNeutral"
          rounded
          icon={<SvgIcon name="dots-horizontal" />}
        />
      </Dropdown.ButtonMinimal>

      <Dropdown.Items>
        <Dropdown.Item
          as={Link}
          leadingIcon={<SvgIcon name="package-plus" />}
          to={adminRoutes.design.createSpaceInCollection(collection.id)}
          onClick={e => {
            e.stopPropagation()
          }}
        >
          <T id="Generics.AddSpace" defaultMessage="Add {SPACE}" />
        </Dropdown.Item>
        <Dropdown.Item
          leadingIcon={<SvgIcon name="list-unordered" />}
          onClick={e => {
            e.stopPropagation()
            openOrganizationModal(collection.id)
          }}
        >
          <T id="Generics.Organize" defaultMessage="Organize" />
        </Dropdown.Item>
        <Dropdown.Item
          leadingIcon={<SvgIcon name="edit" />}
          onClick={e => {
            e.stopPropagation()
            openCollectionModal(collection.id)
          }}
        >
          <T
            id="Blocks.CollectionHeader.EditCollection"
            defaultMessage="Edit {COLLECTION}"
          />
        </Dropdown.Item>
        <Dropdown.Item
          leadingIcon={<SvgIcon name="trash" />}
          onClick={e => {
            e.stopPropagation()
            openDeleteCollectionModal(collection.id)
          }}
        >
          <T defaultMessage="Remove" id="Generics.Remove" />
        </Dropdown.Item>
      </Dropdown.Items>
    </Dropdown>
  )
}
